/** Preserve a tenant color when readable, otherwise select black or white. */
export function readableText(foreground, background) {
    const luminance = (hex) => {
        if (!/^#[0-9a-f]{6}$/i.test(hex))
            return null;
        const channels = [1, 3, 5].map(index => parseInt(hex.slice(index, index + 2), 16) / 255)
            .map(value => value <= 0.04045 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4));
        return channels[0] * 0.2126 + channels[1] * 0.7152 + channels[2] * 0.0722;
    };
    const bg = luminance(background), fg = luminance(foreground);
    if (bg === null)
        return foreground;
    if (fg !== null && (Math.max(bg, fg) + 0.05) / (Math.min(bg, fg) + 0.05) >= 4.5)
        return foreground;
    return (bg + 0.05) / 0.05 >= 1.05 / (bg + 0.05) ? '#000000' : '#FFFFFF';
}
